import { useState } from 'react';
import { HubspotBrochureDownload  } from '.'

const OfferForm = (props) => {
    return (
        <>
        <section className="sectionSpacing pt-01">
          <div className="container customCampaignContainer">
            <div className="row" >
              <div className="offset-sm-2 col-md-8 offset-md-2 mx-auto">
                <h4 className="mainHeadingN  text-center">Time is ticking! Grab the offer now!</h4>
                <div className="subHeading  text-center">
                Fill out this form before 31st March 2021 and we will get back to you shortly.
                </div>
              </div>
              <div className="offset-sm-2 col-md-8 offset-md-2 mx-auto innerSpace whiteForm" id="hubspotForm">
          
                <HubspotBrochureDownload formID="a80734ee-4c6f-44de-b4c4-6cb468c6d482"/>
                </div>
              <div className="offset-sm-2 col-md-8 offset-md-2 mx-auto  whiteForm" >

              <p className="smallfont text-center">We safeguard your personal information in accordance with our <a href="https://www.vantagecircle.com/privacy-policy/" className="companycolor">Privacy Policy</a></p>
              
              </div>
            </div>
          </div>
        </section>
        </>
    );
}

export default OfferForm;



